import React from "react";
import { Icon } from "@countysuite/ui";

export const OkSign: React.FC = () => (
  <div className="centered" style={{ fontSize: "22px", color: "forestgreen" }}>
    <Icon glyph="ok-sign" />
  </div>
);

export const QuestionSign: React.FC = () => (
  <div className="centered" style={{ fontSize: "22px", color: "steelblue" }}>
    <Icon glyph="question-sign" />
  </div>
);

export const CancelSign: React.FC = () => (
  <div className="centered" style={{ fontSize: "22px", color: "#fa4a2f" }}>
    <Icon glyph="remove" />
  </div>
);
